module.exports = __webpack_public_path__ + "static/one-percent-swiper_img02_m-68fe6dee1dc08fe01f38c108a7575d50.jpg";